var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box, Checkbox, ClickAwayListener, createStyles, FormControl, FormLabel, Grid, Grow, IconButton, InputAdornment, InputBase, ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Popper, useControlled, useTheme, withStyles } from '@material-ui/core';
import { Close, Search } from '@material-ui/icons';
import _ from 'lodash';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { DateObject } from 'react-multi-date-picker';
import { language, _T } from '../../../../include/appI18n';
import '../../../../include/jquery-components/date-range-picker';
import '../../../../include/jquery-components/date-range-picker/date-range-picker.css';
import $ from '../../../../include/jquery.js';
import { russian, StyledCalendar } from '../../../../include/react-components/StyledCalendar';
export const TpLabel = (props) => React.createElement(FormLabel, Object.assign({ classes: { root: 'tp-filter-label', focused: 'tp-filter-label-focused' } }, props));
//export const TpLabel = (props: FormLabelProps) => <FormLabel classes={{ root: 'tp-filter-label MuiInputLabel-shrink', focused: 'tp-filter-label-focused' }} {...props} />
export const TpFormControl = withStyles((theme) => createStyles({
    root: {
        verticalAlign: 'baseline',
    },
}))(FormControl);
export const TpInput = React.forwardRef((props, ref) => React.createElement(InputBase, Object.assign({}, props, { classes: Object.assign({ root: 'tp-input-root', input: 'tp-input', disabled: 'tp-input-disabled', error: 'tp-input-error' }, props.classes), ref: ref })));
export const TpMenuItem = (props) => React.createElement(MenuItem, Object.assign({ className: props.selected ? 'tp-list-item-selected' : undefined, classes: { root: 'tp-list-item', gutters: 'tp-list-item-gutters' } }, props));
export const TpArrowIcon = (props) => React.createElement("svg", { className: props.className, width: "8", height: "6", viewBox: "0 0 8 6" },
    React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M3.88281 6L0.393326 -6.52532e-07L7.37229 -4.68497e-08L3.88281 6Z" }));
export const TpArrowIcon2 = (props) => React.createElement("svg", { className: props.className, viewBox: "0 0 24 24" },
    React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M7 10l5 5 5-5z" }));
function TpSelectInner(props, ref) {
    var _a, _b, _c, _d, _e, _f;
    const snackbar = useSnackbar();
    const [open, setOpen] = React.useState(false);
    const [showDropdownContent, setShowDropdownContent] = React.useState(!props.dropdownDelay);
    const anchorRef = React.useRef(null);
    const menuRef = React.useRef(null);
    const getOptionValue = (o) => typeof props.valueSelector == 'function' ? props.valueSelector(o) : o[props.valueSelector];
    const getOptionText = (o) => typeof props.textSelector == 'function' ? props.textSelector(o) : o[props.textSelector];
    const getDisabledState = (o) => typeof props.disabledSelector == 'function' ? props.disabledSelector(o) : false;
    const handleToggle = () => {
        if (!props.disabled)
            setOpen((prevOpen) => !prevOpen);
        else
            setOpen(false);
    };
    const handleClose = (event) => {
        if (anchorRef.current && menuRef.current && menuRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    //useEffect(() => {
    //    if (props.multiselect) {
    //        setSelected(selected.filter(s => !!props.options.find(o => getOptionValue(o) == s)));
    //    } else {
    //        if (!props.options.find(o => getOptionValue(o) == selected[0]))
    //            props.onChange(getOptionValue(options[0]))
    //    }
    //}, [props.options])
    useEffect(() => {
        setTimeout(() => setShowDropdownContent(open), 200);
    }, [open]);
    const handleListKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    };
    const [selected, setSelected] = useState(props.multiselect ? props.selected : props.value !== undefined ? [props.value] : []);
    const [searchText, setSearchText] = useState();
    const [searchOpen, setSearchOpen] = useState(false);
    const options = useMemo(() => searchText && searchOpen ? props.options.filter(o => getOptionText(o).toLowerCase().includes(searchText.toLowerCase())) : props.options, [props.options, searchOpen, searchText]);
    useEffect(() => {
        if (!props.multiselect) {
            return;
        }
        if (!_.isEqual(_.orderBy(selected), _.orderBy(props.selected)))
            props.onChange(selected.filter(s => props.options.findIndex(o => getOptionValue(o) == s) >= 0));
    }, [selected]);
    useEffect(() => {
        if (props.multiselect && props.onChange && !open && !_.isEqual(_.orderBy(selected), _.orderBy(props.selected)))
            props.onChange(selected.filter(s => props.options.findIndex(o => getOptionValue(o) == s) >= 0));
    }, [open]);
    useEffect(() => {
        const newSelected = selected.filter(s => props.options.findIndex(o => getOptionValue(o) == s) >= 0);
        setSelected(newSelected);
        if (props.multiselect && props.onChange && !open && !_.isEqual(_.orderBy(newSelected), _.orderBy(props.selected)))
            props.onChange(newSelected);
    }, [props.options, props.valueSelector]);
    const valueLabel = useMemo(() => {
        if (!props.multiselect) {
            if (props.valueLabelFormat)
                return props.valueLabelFormat(props.value);
            let q = props.value === undefined ? undefined : options.find(p => getOptionValue(p) === props.value);
            if (q !== undefined && q !== null)
                return getOptionText(q);
            return '';
        }
        if (props.valueLabelFormat)
            return props.valueLabelFormat(selected);
        if (selected.length == 0 || selected.length == options.length)
            return (props.anyLabel || _T.COMMON_ANY_MALE);
        return _.orderBy(selected.filter(o => !!o).map(o => {
            let f = options.find(p => getOptionValue(p) == o);
            return f ? getOptionText(f) : '';
        }), v => v).filter(o => o).join(', ');
    }, [selected, options, props.textSelector, props.valueSelector, props.multiselect, (props.multiselect ? props.selected : props.value)]);
    const searchRef = useRef(null);
    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);
    const MultiSelectMenu = //useMemo(() => () => (
     React.createElement(MenuList, { ref: menuRef, autoFocusItem: open, id: "menu-list-grow", onKeyDown: handleListKeyDown, style: { maxHeight: (_a = props.heightPx) !== null && _a !== void 0 ? _a : 300, overflowY: 'auto' } }, options.map((o, i) => {
        let value = getOptionValue(o);
        let text = props.optionSelector && typeof props.optionSelector == 'function' ? props.optionSelector(o) : getOptionText(o);
        return (React.createElement(TpMenuItem, { selected: props.multiselect ? selected.indexOf(value) > -1 : value == props.value, disabled: props.disabled || getDisabledState(o), dense: true, button: true, key: i, onClick: (e) => {
                if (!props.multiselect) {
                    //setSelected([value]);
                    props.onChange(value);
                    setOpen(false);
                    return;
                }
                let newSelected = [];
                if (selected.indexOf(value) > -1) {
                    newSelected = [...selected.filter(x => x != value && !!props.options.find(p => getOptionValue(p) == x))];
                }
                else {
                    newSelected = [...selected.filter(x => !!props.options.find(p => getOptionValue(p) == x)), value];
                }
                if (props.maxSelected && newSelected.length > props.maxSelected && props.maxSelectedAlertText) {
                    snackbar.enqueueSnackbar(props.maxSelectedAlertText, { variant: 'warning', autoHideDuration: 5000 });
                }
                else
                    setSelected(newSelected);
                e.stopPropagation();
            } },
            props.multiselect ? React.createElement(ListItemIcon, null,
                React.createElement(Checkbox, { classes: { root: 'tp-list-item-checkbox', checked: 'tp-list-item-checkbox-selected' }, edge: "start", checked: selected.indexOf(value) > -1, tabIndex: -1, disableRipple: true, disabled: props.disabled })) : null,
            React.createElement(ListItemText, { primary: text })));
    }));
    return (React.createElement(React.Fragment, null, props.multiline ?
        React.createElement(Box, Object.assign({}, ((_b = props.boxProps) !== null && _b !== void 0 ? _b : {})),
            props.label ? React.createElement(TpLabel, { error: props.error }, props.label) : null,
            React.createElement(Box, Object.assign({}, ((_c = props.boxProps) !== null && _c !== void 0 ? _c : {}), { className: props.error ? 'tp-multi-select-error' : '' }),
                !props.searchable || !searchOpen ? React.createElement(TpInput, { onClick: props.onClick, classes: props.inputClasses, disabled: props.disabled, readOnly: true, fullWidth: true, value: valueLabel, placeholder: props.placeholder, startAdornment: props.startAdornment, endAdornment: props.searchable ?
                        React.createElement(InputAdornment, { position: "end" },
                            React.createElement(IconButton, { onClick: e => {
                                    setSearchOpen(true);
                                    setTimeout(() => { var _a; return (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 400);
                                } },
                                React.createElement(Search, { color: "inherit" }))) : undefined, error: props.error }) : React.createElement(TpFormControl, { classes: props.formControlClasses, fullWidth: true },
                    React.createElement(TpInput, { onClick: props.onClick, classes: props.inputClasses, disabled: props.disabled, fullWidth: true, inputRef: searchRef, value: searchText, onChange: (e) => setSearchText(e.target.value), placeholder: props.placeholder, startAdornment: (searchText === null || searchText === void 0 ? void 0 : searchText.length) && searchOpen ?
                            React.createElement(InputAdornment, { position: "start" },
                                React.createElement(IconButton, { onClick: () => setSearchText('') },
                                    React.createElement(Close, { color: "inherit" }))) : props.startAdornment, endAdornment: props.searchable ?
                            React.createElement(InputAdornment, { position: "end" },
                                React.createElement(IconButton, { onClick: e => {
                                        setSearchText('');
                                        setSearchOpen(false);
                                    } },
                                    React.createElement(Search, { color: "inherit" }))) : undefined, error: props.error })),
                React.createElement(Box, { height: props.heightPx },
                    React.createElement(Paper, { elevation: 2, style: { height: '100%' }, className: "tp-multiline-select-list-paper" }, MultiSelectMenu)))) : React.createElement(Box, Object.assign({}, ((_d = props.boxProps) !== null && _d !== void 0 ? _d : {}), { style: { height: '100%' } }),
        React.createElement("div", { style: { display: 'flex', height: '100%' }, ref: anchorRef },
            React.createElement(TpFormControl, { classes: props.formControlClasses, variant: "filled", fullWidth: true, disabled: props.disabled },
                props.label ? React.createElement(TpLabel, { error: props.error }, props.label) : null,
                React.createElement(TpInput, { classes: props.inputClasses, disabled: props.disabled, value: valueLabel, onInput: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }, readOnly: true, placeholder: props.placeholder, style: { caretColor: 'transparent', height: '100%' }, "aria-controls": open ? 'menu-list-grow' : undefined, "aria-haspopup": "true", onClick: () => {
                        let res = true;
                        if (props.onClick)
                            res = props.onClick();
                        if (res)
                            handleToggle();
                    }, startAdornment: props.startAdornment, endAdornment: (_e = props.endAdornment) !== null && _e !== void 0 ? _e : React.createElement(TpArrowIcon, { className: "MuiNativeSelect-icon MuiNativeSelect-iconFilled" }), error: props.error })),
            React.createElement(Popper, { className: 'mui-popper-dropdown', open: open, anchorEl: anchorRef.current, role: undefined, transition: true, style: { zIndex: 9999, width: (_f = anchorRef.current) === null || _f === void 0 ? void 0 : _f.clientWidth, maxHeight: '300px' } }, ({ TransitionProps, placement }) => (React.createElement(Grow, Object.assign({}, TransitionProps, { style: { transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom', marginTop: placement === 'bottom' ? '2px' : 0, marginBottom: placement !== 'bottom' ? '2px' : 0 } }),
                React.createElement(Paper, { elevation: 4 },
                    React.createElement(ClickAwayListener, { onClickAway: handleClose },
                        React.createElement(Box, { width: "100%", height: "100%" }, showDropdownContent || !props.dropdownDelay ? MultiSelectMenu : null))))))))));
}
export const TpSelect = React.forwardRef(TpSelectInner);
export const TpDateRangePickerField2 = React.forwardRef((props, ref) => {
    var _a, _b;
    const snackbar = useSnackbar();
    const minDate = useMemo(() => { var _a; return !((_a = props.validDates) === null || _a === void 0 ? void 0 : _a.length) ? moment().add(1, 'd') : _.minBy(props.validDates.map(d => moment(d, 'YYYY-MM-DD')), d => d.unix()); }, [props.validDates]);
    const [[startDate, endDate], setDates] = useState([props.dates[0] ? moment(props.dates[0]).toDate() : undefined, props.dates[1] ? moment(props.dates[1]).toDate() : undefined]);
    const [errors, setErrors] = useState([]);
    const inputRef = useRef(null);
    const [open, setOpen] = React.useState(false);
    const [showDropdownContent, setShowDropdownContent] = React.useState(false);
    const anchorRef = React.useRef(null);
    const menuRef = React.useRef(null);
    const valueLabel = useMemo(() => startDate && endDate ? (moment(startDate).isSame(endDate) ? moment(startDate).format('DD.MM.YY') : `${moment(startDate).format('DD.MM.YY')} - ${moment(endDate).format('DD.MM.YY')}`) : props.hideLabelWhenNotSelected ? '' : _T.COMMON_SELECT_DATES, [startDate, endDate, props.hideLabelWhenNotSelected]);
    const handleToggle = () => {
        if (!props.disabled)
            setOpen((prevOpen) => !prevOpen);
        else
            setOpen(false);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    const prevOpen = useRef(open);
    // return focus to the button when we transitioned from !open -> open
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);
    useEffect(() => {
        setTimeout(() => setShowDropdownContent(open), 200);
    }, [open]);
    useEffect(() => {
        if (!props.validationCallback)
            return;
        const validationResult = props.validationCallback([startDate ? moment(startDate) : undefined, endDate ? moment(endDate) : undefined]);
        if (!validationResult)
            return;
        if (Array.isArray(validationResult))
            setErrors([...validationResult]);
        else
            setErrors([validationResult]);
    }, [startDate, endDate, props.validationCallback]);
    return (React.createElement("div", { style: { display: 'flex', height: '100%' }, ref: ref },
        React.createElement("div", { style: { display: 'flex', width: '100%', height: '100%' }, ref: anchorRef },
            React.createElement(FormControl, { fullWidth: true, variant: props.variant, classes: props.formControlClasses, error: props.error, disabled: props.disabled, className: props.className },
                props.label ? React.createElement(TpLabel, null, props.label) : null,
                React.createElement(TpInput, { classes: props.inputClasses, disabled: props.disabled, placeholder: props.placeholder, id: props.id, ref: inputRef, value: valueLabel, onInput: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }, readOnly: true, style: { caretColor: 'transparent', color: 'rgba(0, 0, 0, 0.3)' }, "aria-controls": open ? 'menu-list-grow' : undefined, "aria-haspopup": "true", onClick: e => {
                        e.preventDefault();
                        //e.stopPropagation();
                        let res = true;
                        if (props.onClick)
                            res = props.onClick();
                        if (res)
                            handleToggle();
                    }, startAdornment: props.startAdornment, endAdornment: (_a = props.endAdornment) !== null && _a !== void 0 ? _a : React.createElement(TpArrowIcon, { className: "MuiNativeSelect-icon MuiNativeSelect-iconFilled" }), error: props.error })),
            React.createElement(Popper, { className: 'mui-popper-dropdown', open: open, anchorEl: anchorRef.current, role: undefined, transition: true, style: {
                    zIndex: 9999,
                    width: (_b = anchorRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth
                } }, ({ TransitionProps, placement }) => (React.createElement(Grow, Object.assign({}, TransitionProps, { style: {
                    transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom',
                    marginTop: placement === 'bottom' ? '2px' : 0,
                    marginBottom: placement !== 'bottom' ? '2px' : 0
                } }),
                React.createElement(Paper, { elevation: 4 },
                    React.createElement(ClickAwayListener, { onClickAway: handleClose },
                        React.createElement(Box, { width: "100%", height: "100%" }, showDropdownContent || !props.dropdownDelay ? React.createElement(StyledCalendar, { ref: menuRef, range: true, showOtherDays: true, weekStartDayIndex: language.includes('ru') ? 1 : undefined, locale: language.includes('ru') ? russian : undefined, mapDays: ({ date }) => {
                                var s = date.format('YYYY-MM-DD');
                                if (props.validDates === undefined) {
                                    console.error('CheckIn date set is undefined');
                                    return { disabled: false };
                                }
                                return {
                                    disabled: props.validDates.indexOf(s) < 0,
                                };
                            }, minDate: minDate === null || minDate === void 0 ? void 0 : minDate.toDate(), currentDate: minDate ? new DateObject(minDate.toDate()) : undefined, highlightToday: false, numberOfMonths: props.numberOfMonths, value: [startDate, endDate].filter(x => !!x).map(x => x), onChange: value => {
                                let s = value instanceof Date || typeof value == 'string' || typeof value == 'number'
                                    ? [moment(value), undefined]
                                    : value instanceof DateObject
                                        ? [moment(value.format('YYYY-MM-DD')), undefined]
                                        : Array.isArray(value)
                                            ? (value[0] instanceof Date || typeof value[0] == 'string' || typeof value[0] == 'number') && (value[value.length - 1] instanceof Date || typeof value[value.length - 1] == 'string' || typeof value[value.length - 1] == 'number')
                                                ? [moment(value[0]), value.length > 1 ? moment(value[value.length - 1]) : undefined]
                                                : value[0] instanceof DateObject && value[value.length - 1] instanceof DateObject
                                                    ? [moment(value[0].format('YYYY-MM-DD')), value.length > 1 ? moment(value[value.length - 1].format('YYYY-MM-DD')) : undefined]
                                                    : [undefined, undefined]
                                            : [undefined, undefined];
                                if (s[0] == undefined || s[1] == undefined)
                                    return;
                                if (props.dateLimit && s[0].diff(s[1], "days") >= props.dateLimit) {
                                    snackbar.enqueueSnackbar(props.dateLimitAlertText, { variant: 'warning', autoHideDuration: 5000 });
                                }
                                setDates([s[0].toDate(), s[1].toDate()]);
                                if (props.onChange)
                                    props.onChange(s);
                                setOpen(false);
                            } }) : null)))))))));
});
export function TpDateRangePickerField(props) {
    const snackbar = useSnackbar();
    const [[startDate, endDate], setDates] = useState([props.dates[0] ? moment(props.dates[0]) : undefined, props.dates[1] ? moment(props.dates[1]) : undefined]);
    const [errors, setErrors] = useState([]);
    const inputRef = useRef(null);
    const daterangepickerApply = useCallback((e, picker) => {
        if (props.dateLimit && picker.endDate.diff(picker.startDate, "days") >= props.dateLimit) {
            snackbar.enqueueSnackbar(props.dateLimitAlertText, { variant: 'warning', autoHideDuration: 5000 });
        }
        setDates([picker.startDate, picker.endDate]);
        if (props.onChange)
            props.onChange([picker.startDate, picker.endDate]);
    }, [props.onChange]);
    useEffect(() => {
        if (!inputRef.current)
            return;
        $(inputRef.current).daterangepicker({
            startDate: moment(props.dates[0]),
            endDate: moment(props.dates[1]),
            dateLimit: props.dateLimit,
            //startDate: moment($('#checkInDateStart').val()),
            //endDate: moment($('#checkInDateEnd').val()),
            minDate: moment(),
            autoApply: true,
            isInvalidDate: function (date) {
                // ����������� ���� ������� �� �������� � ������ ����������� ��� ������.
                var s = date.format('YYYY-MM-DD');
                if (props.validDates === undefined) {
                    console.error('CheckIn date set is undefined');
                    return false;
                }
                return props.validDates.indexOf(s) < 0;
            },
            //template: props.maxViewMode && props.maxViewMode < 2 ? 
            //    '<div class="daterangepicker dropdown-menu">' +
            //        '<div class="calendar left right">' +
            //            '<div class="daterangepicker_input">' +
            //              '<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
            //              '<input class="input-mini form-control" type="text" name="daterangepicker_end" value="" />' +
            //              '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
            //              '<div class="calendar-time">' +
            //                '<div></div>' +
            //                '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
            //              '</div>' +
            //            '</div>' +
            //            '<div class="calendar-table"></div>' +
            //        '</div>' +
            //        '<div class="ranges">' +
            //            '<div class="range_inputs">' +
            //                '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
            //                '<button class="cancelBtn" type="button"></button>' +
            //            '</div>' +
            //        '</div>' +
            //    '</div>':undefined,
        });
        $(inputRef.current).off('apply.daterangepicker', daterangepickerApply);
        $(inputRef.current).on('apply.daterangepicker', daterangepickerApply);
        return () => {
        };
    }, [inputRef.current, ...props.dates, props.validDates, props.numberOfMonths, daterangepickerApply]);
    useEffect(() => {
        if (!props.validationCallback)
            return;
        const validationResult = props.validationCallback([startDate, endDate]);
        if (!validationResult)
            return;
        if (Array.isArray(validationResult))
            setErrors([...validationResult]);
        else
            setErrors([validationResult]);
    }, [startDate, endDate, props.validationCallback]);
    const valueLabel = useMemo(() => startDate && endDate ? (startDate.isSame(endDate) ? startDate.format('DD.MM.YY') : `${startDate.format('DD.MM.YY')} - ${endDate.format('DD.MM.YY')}`) : _T.COMMON_SELECT_DATES, [startDate, endDate]);
    const theme = useTheme();
    return (React.createElement(FormControl, { fullWidth: true, variant: props.variant, error: props.error, disabled: props.disabled, className: props.className },
        React.createElement(TpLabel, null, props.label),
        React.createElement(TpInput, { disabled: props.disabled, id: props.id, ref: inputRef, value: valueLabel, style: { caretColor: 'transparent', color: 'rgba(0, 0, 0, 0.3)' }, endAdornment: React.createElement(TpArrowIcon, { className: "MuiNativeSelect-icon" }) })));
    //return <DateRangePickerField {...props} input={TpInput} />
}
export function TpDurationSelector(props) {
    const snackbar = useSnackbar();
    const [value] = useControlled({ name: 'value', controlled: props.value, default: props.value });
    const currentMinSelected = useMemo(() => value === undefined || value.length == 0 ? (props.options.length ? props.options[0] : 0) : value[0], [value, props.options]);
    const currentMaxSelected = useMemo(() => value === undefined || value.length == 0 ? (props.options.length ? props.options[props.options.length - 1] : 100) : value[1], [value, props.options]);
    return (React.createElement(Grid, { container: true, spacing: 1 },
        React.createElement(Grid, { item: true, xs: 'auto' },
            React.createElement(Box, { paddingRight: '8px', display: "inline-flex", className: "tp-filter-label" }, _T.COMMON_FROM.toLowerCase()),
            React.createElement(TpSelect, { value: currentMinSelected, onChange: (v) => {
                    let start = v;
                    let end = (() => {
                        var _a;
                        if (!value || value.length == 0 || (props.tourSearchMaxNightCount && props.options.indexOf(value[1]) - props.options.indexOf(v) >= props.tourSearchMaxNightCount)) {
                            if ((value === null || value === void 0 ? void 0 : value.length) == 2)
                                snackbar.enqueueSnackbar(_T.NEW_TOUR_SEARCH_DURATIONS_WARNING_MAX_SET_MAX);
                            return (_a = (props.tourSearchMaxNightCount ? props.options[props.options.indexOf(v) + props.tourSearchMaxNightCount - 1] : undefined)) !== null && _a !== void 0 ? _a : props.options[props.options.length - 1];
                        }
                        if (v > value[1]) {
                            snackbar.enqueueSnackbar(_T.NEW_TOUR_SEARCH_DURATIONS_WARNING_MAX_SET_MIN);
                            return v;
                        }
                        return value[1];
                    })();
                    //let end = Math.min(Math.max(v, value ? value[1] : props.options.length ? getMaxValue(start) : 100), getMaxValue(start));
                    props.onChange([start, end]);
                }, options: props.options, valueSelector: o => o, textSelector: o => `${o}`, required: true, error: props.error, boxProps: {
                    display: 'inline-flex',
                    width: '82px',
                } })),
        React.createElement(Grid, { item: true, xs: 'auto' },
            React.createElement(Box, { paddingRight: '8px', display: "inline-flex", className: "tp-filter-label" }, _T.COMMON_TO.toLowerCase()),
            React.createElement(TpSelect, { value: currentMaxSelected, onChange: (v) => {
                    //let start = Math.min(v, value ? value[0] : props.options.length ? props.options[0] : 0);
                    let start = (() => {
                        var _a;
                        if (!value || value.length == 0 || (props.tourSearchMaxNightCount && props.options.indexOf(v) - props.options.indexOf(value[0]) >= props.tourSearchMaxNightCount)) {
                            if ((value === null || value === void 0 ? void 0 : value.length) == 2)
                                snackbar.enqueueSnackbar(_T.NEW_TOUR_SEARCH_DURATIONS_WARNING_MIN_SET_MIN);
                            return (_a = (props.tourSearchMaxNightCount ? props.options[props.options.indexOf(v) - props.tourSearchMaxNightCount + 1] : undefined)) !== null && _a !== void 0 ? _a : props.options[0];
                        }
                        if (v < value[0]) {
                            snackbar.enqueueSnackbar(_T.NEW_TOUR_SEARCH_DURATIONS_WARNING_MIN_SET_MAX);
                            return v;
                        }
                        return value[0];
                    })();
                    let end = v;
                    props.onChange([start, end]);
                }, options: props.options, valueSelector: (o) => o, textSelector: (o) => `${o}`, required: true, error: props.error, boxProps: {
                    display: 'inline-flex',
                    width: '82px',
                } }))));
}
export function CustomPopper(props) {
    const { anchorEl, style, children } = props, other = __rest(props, ["anchorEl", "style", "children"]);
    const width = anchorEl ? anchorEl.clientWidth : undefined;
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(true);
        }, 50);
        return () => clearTimeout(timer); // чистим таймер при размонтировании
    }, []);
    return (React.createElement(Popper, Object.assign({}, other, { anchorEl: anchorEl, style: Object.assign(Object.assign({}, style), { width: width, display: visible ? undefined : 'none' }), placement: "bottom", modifiers: {
            flip: {
                enabled: false, // ОТКЛЮЧАЕМ автопереворот
            },
            preventOverflow: {
                enabled: false, // по желанию — можно оставить true если хочешь чтоб он не вылезал за вьюпорт
            },
        } }), ({ TransitionProps, placement }) => (React.createElement(Grow, Object.assign({}, TransitionProps, { style: {
            transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom',
            //marginTop: '-j4px',
            //marginTop: placement === 'bottom' ? '2px' : 0,
            //marginBottom: placement !== 'bottom' ? '2px' : 0
        } }),
        React.createElement(React.Fragment, null, children)))));
}
